<template>
  <div>
    <nav-breadcrumb :menu="[{label: '核心企业列表'}]"/>
    <div class="bg-purple xzpadd105">
      <data-table-component
        :tableData="debtorListData"
        :columns="debtorListColumns"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :page.sync="page"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import {removeItem, xmlBuildQuery} from '../../../filters/CommonActions'
  import moment from 'moment'
  import DataTableComponent from "../../../components/DataTable";

  export default {
    components: {DataTableComponent},
    data() {
      return {
        page: 1,
        pageSize: 10,
        debtorListData: {},
        debtorListColumns: [
          {
            name: '企业编号',
            field: 'c__customerId'
          },
          {
            name: '企业名称',
            field: 'c__customerName'
          },
          {
            name: '供应链名称',
            field: 'c__customerName'
          },
          {
            name: '统一社会信用代码',
            field: 'i__socialIdentityCode'
          },
          {
            name: '联系人姓名',
            field: 'i__contactPerson'
          },
          {
            name: '联系人手机',
            field: 'i__contactTelNo'
          },
          {
            name: '联系人电话',
            field: 'i__contactTelNo2'
          },
          {
            name: '创建时间',
            field: 'c__createdDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD hh:mm')
            }
          },
          {
            name: '操作',
            opts:[
              {
                class: 'el-icon-edit',
                name: '编辑',
                clickHandler: (index, row)=>{
                  this.editItem(index, row)
                }
              },
            ]
          }
        ],
        filters: {
          form: {
            c__customerName: '',
            i__socialIdentityCode: '',
            i__contactPerson: '',
            c__createdDate: [],
            i__contactTelNo: ''
          },
          columns: [
            {
              label: '企业名称',
              component: 'el-input',
              field: 'c__customerName'
            },
            {
              label: '信用代码',
              component: 'el-input',
              field: 'i__socialIdentityCode'
            },
            {
              label: '联系人姓名',
              component: 'el-input',
              field: 'i__contactPerson'
            },
            {
              label: '创建日期',
              component: 'date-range-picker',
              field: 'c__createdDate',
              op:['gteq', 'lteq']
            },
            {
              label: '联系人手机',
              component: 'el-input',
              field: 'i__contactTelNo'
            }
          ],
          onSubmit:()=>{
            this.page = 1
            this.getDebtorList()
          }
        }
      }
    },
    computed : {
      filterParams: {
        get: function () {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
            'xlist.sort.dataField': 'c.createdDate',
            'xlist.sort.order': 'desc'
          }
        },
        set:function (newVal) {

        }
      }
    },
    watch: {
      filterParams: function () {
        this.getDebtorList()
      },
    },
    mounted() {
      this.getDebtorList()
    },
    methods: {
      getDebtorList: function () {
        xhr.getDebtorList(
          Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
          res => {
            try {
              this.debtorListData = res.data
            } catch (e) {

            }
          })

      },
      editItem: function (index, row) {
        try{
          this.$router.push({
            'path': 'Edit?c.customerId='+row.c__customerId
          })
        }catch (e) {

        }
      },
      deleteItem: function (index, row) {
        removeItem(
          xhr.deleteDebtor,

          {
            'u.userId': row.u__userId
          },

          ()=>{
            this.getDebtorUserList()
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/DebtorList.vue